import { faBackward, faForward } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Moment } from "moment"
import React, { PropsWithChildren } from "react"
import type { SearchActionParams } from '../Notification.types';

interface NotificationsListSearchProps {
    search: string | null
    date: string | null
    onClick: ((params: SearchActionParams) => void)
    searchText?: string
}


export const NotificationsYearMonth = (props: { date: Moment, changeDate: ((date: Moment) => void) }) => {
    const [selectedYear, selectedMonth] = props.date?.format("YYYY-MM").split("-").map((x) => parseInt(x)) || [0, 0];
    const date = new Date();
    const latestYear = date.getUTCFullYear();
    const startYear = 2013;
    const years = [<option key="year" value="">Year</option>];
    for (let index = latestYear; index >= startYear; index--) {
        years.push(<option key={index} value={index}>{index}</option>)
    }

    const yearEl = React.useRef<HTMLSelectElement>(null);
    const monthEl = React.useRef<HTMLSelectElement>(null);

    return <>
        <div key={`${selectedYear}-${selectedMonth}`} className='py-2 my-auto mx-auto user-select-none' style={{ maxWidth: "30rem" }}>
            <div className='d-flex flex-row my-auto align-items-center'>
                <div className='px-2'>
                    <div role='button' onClick={() => props.changeDate(props.date.clone().subtract(1, 'months'))}><FontAwesomeIcon icon={faBackward} /></div>
                </div>
                <div className="input-group">
                    <select data-testid="search-year" ref={yearEl} defaultValue={selectedYear} className="form-select" name="year" id="year"
                        onChange={(e) => props.changeDate(props.date.clone().year(parseInt(e.target.value)))}
                    >{years}</select>
                    <select data-testid="search-month" ref={monthEl} defaultValue={selectedMonth} className="form-select" name="month" id="month"
                        onChange={(e) => props.changeDate(props.date.clone().month(parseInt(e.target.value) - 1))}
                    >
                        <option key="0" value="">Month</option>
                        <option key="1" value="1">January</option>
                        <option key="2" value="2">February</option>
                        <option key="3" value="3">March</option>
                        <option key="4" value="4">April</option>
                        <option key="5" value="5">May</option>
                        <option key="6" value="6">June</option>
                        <option key="7" value="7">July</option>
                        <option key="8" value="8">August</option>
                        <option key="9" value="9">September</option>
                        <option key="10" value="10">October</option>
                        <option key="11" value="11">November</option>
                        <option key="12" value="12">December</option>
                    </select>
                </div>
                <div className='px-2' >
                    <div role='button' onClick={() => props.changeDate(props.date.clone().add(1, 'months'))}><FontAwesomeIcon icon={faForward} /></div>
                </div>
            </div>
        </div>
    </>
};


export default function NotificationsListSearch(props: PropsWithChildren<NotificationsListSearchProps>) {
    const inputElem = React.useRef<HTMLInputElement>(null);
    const yearEl = React.useRef<HTMLSelectElement>(null);
    const monthEl = React.useRef<HTMLSelectElement>(null);

    const buttonOnClick = (event: React.BaseSyntheticEvent) => {
        event.preventDefault();
        const searchValue = inputElem?.current?.value || "";
        const monthValue = monthEl?.current?.selectedOptions[0].value || "";
        const yearValue = yearEl?.current?.selectedOptions[0].value || "";
        const params: SearchActionParams = {};

        if (searchValue) {
            params.search = searchValue;
        }
        if (yearValue && monthValue) {
            params.creation_month = `${yearValue}-${monthValue}`;
        }

        props.onClick(params);
    }

    const clear = (event: React.BaseSyntheticEvent) => {
        event.preventDefault();
        if (inputElem.current) { inputElem.current.value = ""; }
        if (monthEl.current) { monthEl.current.value = ""; }
        if (yearEl.current) { yearEl.current.value = ""; }
        props.onClick({});
    }

    const date = new Date();
    const [selectedYear, selectedMonth] = props.date?.split("-").map((x) => parseInt(x)) || [0, 0];
    const latestYear = date.getUTCFullYear();
    const startYear = 2013;
    const years = [<option key="year" value="">Year</option>];
    for (let index = latestYear; index >= startYear; index--) {
        years.push(<option key={index} value={index}>{index}</option>)
    }


    return (
        <form action="" className="col-lg-8" method="get">
            <div className="input-group">
                <input data-testid="search-input" ref={inputElem} className="form-control input-group-text col-lg-8" type="text" name="search" id="search" defaultValue={props.search || undefined} placeholder={props.searchText || "Country, River, or Basin"} />
            </div>
            <div className="input-group">
                <select data-testid="search-year" ref={yearEl} defaultValue={selectedYear} className="form-select" name="year" id="year">{years}</select>
                <select data-testid="search-month" ref={monthEl} defaultValue={selectedMonth} className="form-select" name="month" id="month">
                    <option key="0" value="">Month</option>
                    <option key="1" value="1">January</option>
                    <option key="2" value="2">February</option>
                    <option key="3" value="3">March</option>
                    <option key="4" value="4">April</option>
                    <option key="5" value="5">May</option>
                    <option key="6" value="6">June</option>
                    <option key="7" value="7">July</option>
                    <option key="8" value="8">August</option>
                    <option key="9" value="9">September</option>
                    <option key="10" value="10">October</option>
                    <option key="11" value="11">November</option>
                    <option key="12" value="12">December</option>
                </select>
                <button data-testid="search-search" className="btn btn-outline-primary" onClick={buttonOnClick}>Search</button>
                <button data-testid="search-clear" className="btn btn-outline-warning" onClick={clear}>Clear</button>
            </div>
        </form>
    )
}